export enum PolicySectionType {
    custom = 1,
    header = 2,
    content = 3,
    subContent = 4,
    list = 5,
}
